// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "@37signals/lexxy"

import TurboPower from 'turbo_power'
TurboPower.initialize(Turbo.StreamActions)

import '@turbo-boost/streams'

